<template>
    <div class="popup" :class="{ 'popup--mini': selectedSupplierBlock.title !== 'Участники тендеров' }" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">{{ selectedSupplierBlock.title }}</div>
                <div class="popup__close" @click="$emit('close')"></div>
            </div>
            <div class="popup__content">
                <table class="table-inner">
                    <thead class="table-inner__head">
                        <tr class="table-inner__row">
                            <template v-if="selectedSupplierBlock.title === 'Участники тендеров'">
                                <td class="table-inner__col">№ <br> тендера</td>
                                <td class="table-inner__col">№ <br> позиции</td>
                                <td class="table-inner__col">Наименование </td>   
                                <td class="table-inner__col">Название тендера</td>
                                <td class="table-inner__col">Название товара</td>
                            </template>
                            <template v-else>
                                <td class="table-inner__col">№ </td>
                                <td class="table-inner__col">Наименование </td>      
                            </template>
                            
                        </tr>
                    </thead>
                    <tbody class="table-inner__body">
                        <tr class="table-inner__row" v-for="offer in supplierBlock.items" :key="offer.id">
                            <template v-if="selectedSupplierBlock.title === 'Участники тендеров'">
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">№ тендера</span>
                                    <span class="table-inner__col-cont">{{ offer.tenderId }}</span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">№ <br> позиции</span>
                                    <span class="table-inner__col-cont">{{ offer.positionId }}</span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Наименование</span>
                                    <span class="table-inner__col-cont">
                                        <button @click="handleOpenSupplier(offer.userId)" class="table__col-cont table__col-cont--green">
                                            <b>{{ offer.name }} </b>
                                        </button>
                                    </span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Название тендера</span>
                                    <span class="table-inner__col-cont">
                                        <a :href="`/personal/tenders/?ID=${offer.tenderId}`" target="_blank" class="table__col-cont table__col-cont--green">
                                            <b>{{ offer.tenderName }}</b>
                                        </a>
                                    </span>
                                </td> 
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Название товара</span>
                                    <span class="table-inner__col-cont">{{ offer.productName }}</span>
                                </td> 
                            </template>
                            <template v-else>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">№</span>
                                    <span class="table-inner__col-cont">{{ offer.id }}</span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Наименование</span>
                                    <span class="table-inner__col-cont">
                                         <template v-if="selectedSupplierBlock.title === 'Тендеры' || selectedSupplierBlock.title === 'Коммерческие предложения' ">
                                            <a :href="`/personal/tenders/?ID=${offer.id}`" target="_blank" class="table__col-cont table__col-cont--green">
                                                <b>{{ offer.name }}</b>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <button @click="handleOpenSupplier(offer.id)" class="table__col-cont table__col-cont--green">
                                                <b>{{ offer.name }}</b>
                                            </button>
                                        </template>
                                    </span>
                                </td>  
 
                            </template>      
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination">
                <vue-awesome-paginate
                    v-if="supplierBlock?.countTotal > filter.limit"
                    :total-items="+supplierBlock?.countTotal"
                    :items-per-page="filter.limit"
                    :max-pages-shown="3"
                    v-model="currentPage"
                    :on-click="changePage" />
            </div>
        </div>
        
    <teleport to="body">
        <transition-group name="modal">
            <SupplierPopup v-if="ShowSupplierPopup" :supplier="selectedSupplier" :canEdit="false" @close="ShowSupplierPopup = false"/>
        </transition-group>
    </teleport>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import SupplierPopup from "@/components/sections/Suppliers/SupplierPopup.vue";

export default {
    name: 'StatsBlockPopup',
    components: {SupplierPopup},
    props: {
        selectedSupplierBlock: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            ShowSupplierPopup: false,
            selectedSupplier: null,
            filter: {
                productName: '',
                tenderName: '',
                total: 0,
                offset: 0,
                limit: 10,
            },
            currentPage: 1,
        }
    },
    mounted() {
        this.requestBlock({key: this.selectedSupplierBlock.key, search: this.filter})
    },
    computed: {
        ...mapGetters({
            supplierBlock: 'stats/getSupplierBlock'
        })
    },
    methods: {
		async changePage(value) {
			this.filter.offset =  (value - 1) * this.filter.limit || 0
			await this.requestBlock({key: this.selectedSupplierBlock.key, search: this.filter})
		},
        async handleOpenSupplier(id) {
            if (!id) return
            const res = await this.requestSupplier(id);

            if (res.success) {
                this.selectedSupplier = res.data;
                this.ShowSupplierPopup = true;
            }
        },
        ...mapActions({
			requestSupplier: 'suppliers/requestSupplier',
            requestBlock: 'stats/requestBlock',
		})
    },
}
</script>
